import React from "react";
import { CnftDetailTable } from "./CnftDetailTable";
import { ProcessedMetadata } from "../client/Metadata";
import { ifString } from "../client";

interface Props {
  collection?: String;
  tokenId?: BigInt;
  metadata: ProcessedMetadata;
  decryptionKey?: String;
  owner?: String;
}

// TODO: Make collection, tokenid and owner optional
export function CnftDisplay({
  collection,
  tokenId,
  metadata,
  decryptionKey,
  owner,
}: Props) {
  const isCNFT = metadata.confidential !== undefined;

  let nft_name;
  if (ifString(metadata.name$confidential) && ifString(metadata.name)) {
    // TODO: Make the public name gray?
    nft_name = (
      <>
        {metadata.name$confidential}{" "}
        <span className="overwritten">({metadata.name as string})</span>
      </>
    );
  } else {
    nft_name =
      ifString(
        metadata.name$confidential ?? // Show confidential if known
          metadata.name,
      ) ?? // Otherwise: Fall back to the public value
      (isCNFT ? "[HIDDEN NAME]" : "[Unnamed]"); // Otherwise: Doesn't have a name known to us.
  }

  const cnft_label = <span className="cnft-label">cNFT</span>;
  const normal_label = <span className="normal-label">Normal NFT</span>;

  return (
    <div>
      <h2 className="nft-name">{nft_name}</h2>
      {isCNFT ? cnft_label : normal_label}

      <CnftDetailTable
        collection={collection}
        tokenId={tokenId}
        metadata={metadata}
        decryptionKey={decryptionKey}
        owner={owner}
      />
    </div>
  );
}
